import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import WelcomeConstants from '../pages/welcome/constants';
import Auth from '../app/contexts/auth';

interface IPrivateRouteProps {
    accessRole?: string | string[];
}

function PrivateRouteComponent({
    children,
    accessRole = '',
}: PropsWithChildren<IPrivateRouteProps>): any {
    const { user, isAuthorized } = Auth.useAuth();

    if (user && (accessRole === '' || isAuthorized(accessRole))) {
        return children;
    }

    return (
        <Navigate
            to={{
                pathname: WelcomeConstants.default,
            }}
            state="login_failed"
        />
    );
}

export default PrivateRouteComponent;
